/* jshint esversion: 6 */
/* global $, window,  */


// const $commentsModule = $('#comments-module');
// const $productBox = $('<section class="page-product-box"></section>');
// $commentsModule.append($productBox);
//
// const $productFooter = $('.product-footer');
// const $crosselling = $('.similar-product-list');

import vars from './variables';

require('velocity-animate');

class ModuleLoader {
    constructor() {
        this.modules = [];

        window.addEventListener('scroll', () => this.lazyLoadModules(), {
            passive: true
        });


    }

    lazyLoadModules() {
        const offset = 500;
        for (const module of this.modules) {
            if (!module.loaded && typeof module.loading === 'undefined') {

                if (!(module.container instanceof jQuery)) {
                    module.container = $(module.container);
                }

                const top = module.container.offset().top - offset;
                const bottom = top + module.container.outerHeight(true) + offset;

                const windowTop = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
                const windowBottom = windowTop + window.innerHeight;

                if (module.hook === 'displaySimilarProducts') {
                    this.loadModule(module);
                } else {
                    if (windowBottom > top && windowTop < bottom) {
                        this.loadModule(module);
                    }
                }

            }
        }
    }

    loadHook(hook) {
        return new Promise(resolve => {
            $.ajax({
                type: 'POST',
                url: `${baseDir}modules/productcard/ajax.php`,
                data: {
                    id_product,
                    action: 'LoadHook',
                    hook,
                },
                success: res => {
                    resolve(res);
                }
            });
        });
    }

    loadModule(module) {
        if (typeof module === 'string') {
            for (const m of this.modules) {
                const hooks = typeof m.hook === 'string' ? [m.hook] : [...m.hook];
                if (hooks.indexOf(module) !== -1 || m.component.indexOf(moudle) !== -1) {
                    module = m;
                    break;
                }
            }
        }

        const hook = module.hook;


        return new Promise(resolve => {
            if (!module.loaded && typeof module.loading === 'undefined') {
                module.loading = true;
                if (typeof hook === 'object') {
                    const hooks = [];
                    for (const h of hook) {
                        hooks.push(this.loadHook(h));
                    }
                    Promise.all(hooks).then(data => this.initModule(data, module, resolve));
                } else if (hook === false) {
                    this.initModule(false, module, resolve);
                } else {
                    this.loadHook(hook).then(data => this.initModule(data, module, resolve));
                }
            } else {
                resolve(module);
            }
        });
    }

    initModule(data, module, resolve) {
        const container = module.container;
        if (data) {
            container.append(data);
        }

        container.css({height: 'auto', opacity: 0});

        this.loadScripts(module).then(_ => {
            module.loaded = true;
            if (_.show) {
                _.module.container.velocity('fadeIn');
            } else {
                _.module.container.hide();
            }

            container.css('height', '').addClass('loaded');

            const input_selector = 'input[type=text], input[type=password], input[type=email], input[type=url], input[type=tel], input[type=number], input[type=search], textarea';

            container.find(input_selector).filter(function () {
                return $(this).val();
            }).siblings('label').addClass('active');

            resolve(module);
        });
    }

    loadScripts(module) {
        return new Promise(resolve => {
            module.resolve(({default: init}) => {
                resolve({module, show: init()});
            });
        });
    }

    addModule(component, container, hook = false) {
        return new Promise(resolve => {
            this.modules.push({
                component,
                hook,
                container,
                resolve
            });

            this.lazyLoadModules();
        });

    }

}

const moduleLoader = new ModuleLoader();

export default moduleLoader;
